



























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import dayjs from 'dayjs'
import { getAllDatesOfMonth } from '@/utils/datetime'
import { DatetimeString } from '@/types/utils'
import { createDatetimeString } from '@/utils/datetime'

enum InputTypes {
  YEAR,
  MONTH,
  DAY,
  HOUR,
  MINUTE
}

const TODAY = dayjs()
const TODAY_OF_LAST_YEAR = TODAY.subtract(1, 'year')
const TODAY_OF_NEXT_YEAR = TODAY.add(1, 'year')

@Component({
  components: {
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue')
  }
})
export default class PdCreateRegisteredDatetimeInputGroup extends mixins(
  InputGroup
) {
  @Prop(String) value!: DatetimeString

  get valueAsDayjs() {
    return dayjs(this.value)
  }

  get inputYear() {
    return this.valueAsDayjs.year()
  }

  set inputYear(value: number) {
    if (this.monthOptions.indexOf(this.inputMonth) === -1) {
      this.inputMonth = this.monthOptions[0]
      this.inputDay = this.dayOptions[0]
    } else if (
      !this.inputDay ||
      this.dayOptions.indexOf(this.inputDay) === -1
    ) {
      this.inputDay = this.dayOptions[0]
    }

    this.$emit('input', this.generateNewValue(InputTypes.YEAR, value))
  }

  get inputMonth() {
    return this.valueAsDayjs.month() + 1
  }

  set inputMonth(value: number) {
    if (this.dayOptions.indexOf(this.inputDay) === -1) {
      this.inputDay = this.dayOptions[0]
    }

    this.$emit('input', this.generateNewValue(InputTypes.MONTH, value))
  }

  get inputDay() {
    return this.valueAsDayjs.date()
  }

  set inputDay(value: number) {
    this.$emit('input', this.generateNewValue(InputTypes.DAY, value))
  }

  get inputHour() {
    return this.valueAsDayjs.hour()
  }

  set inputHour(value: number) {
    this.$emit('input', this.generateNewValue(InputTypes.HOUR, value))
  }

  get inputMinute() {
    return this.valueAsDayjs.minute()
  }

  set inputMinute(value: number) {
    this.$emit('input', this.generateNewValue(InputTypes.MINUTE, value))
  }

  get yearOptions() {
    const start = TODAY_OF_LAST_YEAR.year()
    const end = TODAY_OF_NEXT_YEAR.year()
    return [...new Array(end - start + 1)].map((_, i) => start + i)
  }

  get monthOptions() {
    if (!this.inputYear) {
      return []
    }
    return this.generateMonthOptions(this.inputYear)
  }

  get dayOptions() {
    if (!this.inputYear || !this.inputMonth) {
      return []
    }
    return getAllDatesOfMonth(this.inputYear, this.inputMonth)
  }

  get hourOptions() {
    return [...new Array(24)].map((_, i) => i)
  }

  get minuteOptions() {
    return [...new Array(60)].map((_, i) => i)
  }

  generateNewValue(type: InputTypes, value: number) {
    switch (type) {
      case InputTypes.YEAR:
        return createDatetimeString(
          value,
          this.inputMonth - 1,
          this.inputDay,
          this.inputHour,
          this.inputMinute
        )
      case InputTypes.MONTH:
        return createDatetimeString(
          this.inputYear,
          value - 1,
          this.inputDay,
          this.inputHour,
          this.inputMinute
        )
      case InputTypes.DAY:
        return createDatetimeString(
          this.inputYear,
          this.inputMonth - 1,
          value,
          this.inputHour,
          this.inputMinute
        )
      case InputTypes.HOUR:
        return createDatetimeString(
          this.inputYear,
          this.inputMonth - 1,
          this.inputDay,
          value,
          this.inputMinute
        )
      case InputTypes.MINUTE:
        return createDatetimeString(
          this.inputYear,
          this.inputMonth - 1,
          this.inputDay,
          this.inputHour,
          value
        )
      default:
        throw new Error(`type value of '${type}' is invalid`)
    }
  }

  generateMonthOptions(selectedYear: number) {
    const lastYear = TODAY_OF_LAST_YEAR.year()
    const nextYear = TODAY_OF_NEXT_YEAR.year()
    const thisMonth = TODAY.month() + 1

    if (selectedYear === lastYear) {
      return [...new Array(12 - thisMonth)].map((_, i) => i + thisMonth + 1)
    }

    if (selectedYear === nextYear) {
      return [...new Array(thisMonth)].map((_, i) => i + 1)
    }

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }
}
